import {Set} from 'immutable';

/**
 * Create avg/delta for trends.
 *
 * Handy to make only once and re-use.
 */
export function trendMetrics(trends) {
  return trends.map(t => ({
    trend: t,
    // overall average of the data we have for this trend
    avg: t.data.map(d => d.value).reduce((a, b) => a + b, 0) / t.data.size || 0,
    // net improvement (can be pos or neg)
    // note this is naive, could be improved to generate slope of line of actual trend
    delta: t.data.size <= 2 ? 0 : t.data.get(t.data.size - 1).value - t.data.get(0).value,
  }));
}

export const BEST_AND_WORST = 'Best and worst';

/**
 * Sort and provide various trend groupings
 *
 * @param max (amount to take)
 */
export const groupings = (max = 7) => ({
  'Best and worst': trendMetrics => {
    const tm = trendMetrics.sort((l, r) => r.avg - l.avg);
    const take = Math.ceil(max / 2);
    return Set(
      tm
        .slice(0, take)
        .concat(tm.reverse().slice(0, max - take))
        .map(t => t.trend)
    ).toList();
  },
  'Best average': trendMetrics =>
    trendMetrics
      .sort((l, r) => r.avg - l.avg)
      .slice(0, max)
      .map(t => t.trend),
  'Worst average': trendMetrics =>
    trendMetrics
      .sort((l, r) => l.avg - r.avg)
      .slice(0, max)
      .map(t => t.trend),
  'Most improved': trendMetrics =>
    trendMetrics
      .sort((l, r) => r.delta - l.delta)
      .slice(0, max)
      .map(t => t.trend),
  'Worst drop': trendMetrics =>
    trendMetrics
      .sort((l, r) => l.delta - r.delta)
      .slice(0, max)
      .map(t => t.trend),
  'Show all': trendMetrics => trendMetrics.map(t => t.trend),
});
